import { useMemo } from 'react';

import { useTranslation } from '../../../../hooks/useTranslation';
import { doesPhoneTypeMatchSearch } from './doesPhoneTypeMatchSearch';
import { PhoneType } from '../../../../types';

type UsePhoneTypeOptionsProps = {
  search: string;
};

export const usePhoneTypeOptions = ({ search }: UsePhoneTypeOptionsProps) => {
  const { t } = useTranslation();
  return useMemo(
    () =>
      Object.values(PhoneType)
        .map((phoneType) => ({
          title: t(`v2.conditionBuilder.phoneType.${phoneType}`),
          value: phoneType.toString(),
        }))
        .filter((option) => doesPhoneTypeMatchSearch(option.title, search))
        .sort(({ title: a }, { title: b }) => a.localeCompare(b)),
    [t, search],
  );
};
